import React from "react";
import { useSelector } from "react-redux";
import FunnelGraph from "../../../../components/charts/funnelGraph/funnelGraph";

export const IntroOfferFunnelGraph = () => {
  let {
    labels,
    subLabels,
    values,
    averageValues,
    rawDataValues,
    subPercents,
    breakdownRawData,
    percentLabels
  } = useSelector((state) => state.laser.funnelIntroOffers.chart.data);

  const averageTooltip = useSelector((state) => state.laser.averageTooltip);
  const showGraphWithoutValues = useSelector((state) => state.laser.showGraphWithoutValues);

  return (
    <FunnelGraph
      id="introOfferFunnelChart"
      colors={[
        ["#0099ce", "#005a79"],
        ["#42b77a", "#20583b"],
        ["#ff664e", "#6d2e24"],
        ["#5873fd", "#28326b"]
      ]}
      direction="horizontal"
      gradientDirection="vertical"
      labels={labels}
      subLabels={subLabels}
      averageValues={averageValues}
      averageTooltip={averageTooltip}
      hideSubLabels
      subLabelVisibility={[false, true, true, true]}
      width={1350}
      height={450}
      values={values}
      rawDataValues={rawDataValues}
      subPercents={subPercents}
      breakdownRawData={breakdownRawData}
      showGraphWithoutValues={showGraphWithoutValues}
      percentLabels={percentLabels} //[["Lead to Appointment"], ["Lead to Show", "Appointment to Show"], ["Lead to Enrollment", "Show to Enrollment"]]
      container="funnelV2"
    />
  );
};
